import React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import classnames from 'classnames';
import Footer from '../Footer';
import useStyles from './styles';

// import Header from '../Header';
// import Footer from '../Footer';
// import Sidebar from '../Sidebar';
import Client from '../../pages/clientview/Client';
import Emails from '../../pages/client-emails/Emails';

import ClientHeader from '../ClientHeader/ClientHeader';

function LayoutClientView(props) {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <>
                <ClientHeader history={props.history} />
                <div
                    className={classnames(classes.content, {
                        [classes.contentShift]: true
                    })}
                >
                    <div className={classes.fakeToolbar} />
                    <Switch>
                        <Route exact path="/status-page" component={Client} />
                        <Route path="/status-page/emails" component={Emails} />
                    </Switch>
                </div>
                <Footer history={props.history} />
            </>
        </div>
    );
}

export default withRouter(LayoutClientView);
